<template>
  <tr>
    <td v-if="checkbox">
      <div class="v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light" primary="">
        <div class="v-input__control">
          <div class="v-input__slot">
            <!-- TODO -->
            <v-checkbox />
          </div>
        </div>
      </div>
    </td>
    <td v-for="(header, j) in headers" :key="`td-row_${index}-col_${j}`">
      <!-- <slot v-bind:header="header" v-bind:row="row"> -->
      {{ accessItemValue(header, row.data) }}
      <!-- </slot> -->
    </td>
  </tr>
</template>
<script>
  import VirtualCollectionUtil from '@/components/mixins/VirtualCollectionUtil'
  export default {
    mixins: [VirtualCollectionUtil],
    props: {
      index: {
        type: Number,
      },
      source: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      headers() {
        return this.source.headers
      },
      row() {
        return this.source.row
      },
    },
  }
</script>